export const environment = {
  production: true,
  baseUrl: 'https://ulalachef.com/api'
};



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/environments/environment.ts